import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../layouts/FullPage';

// TODO: Import components

interface IAgreementPageProps extends RouteComponentProps { }

interface IState { }

class AgreementPage extends React.Component<IAgreementPageProps, IState> {
    // Define the constructor for the agreement page
    constructor (props: IAgreementPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the agreement container
    render () {
        return (
            <FullPage>
                Agreement page
            </FullPage>
        );
    }
}

export default AgreementPage;
